// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3Mxvf","HeaderLogo":"Header_HeaderLogo__boS0O","HeaderTitle":"Header_HeaderTitle__26tAN"};